/*
 * Functions dealing with storing authentication status in the session.
 */

import _ from 'lodash';

import User from '../common/models/user.model';
import ngStorage from '../../common/wrappers/ngstorage';
import authServiceMod from './auth.service';
import Address from '../common/models/address.model';

/**
 * Check if authentication status is stored in the user's session storage and set values based on that.
 *
 * This is used to prevent flashing of content; if session contains state that user is authed, we can already start
 * rendering the authed user content before getting the real status from the server.
 */
function checkSessionAuth($log, $sessionStorage, AuthService) {
  'ngInject';

  if ($sessionStorage.authservice_authed != null && _.isObject($sessionStorage.authservice_authed)) {
    const user = _deserialize($sessionStorage.authservice_authed);
    AuthService._setUser(user, false);
  }
}
checkSessionAuth.imports = [ngStorage, authServiceMod];

/**
 * Keep session storage in sync with authentication status by storing user data in session whenever it changes. If user
 * logs out, clear user information from session storage.
 */
function syncAuthToSession($log, $timeout, $sessionStorage, AuthService) {
  'ngInject';

  AuthService.subscribeUser(u => {
    $timeout(() => {
      let user_data = null;

      if (u != null) {
        user_data = _serialize(u);
      }

      $sessionStorage.authservice_authed = user_data;
    });
  });
}
syncAuthToSession.imports = [ngStorage, authServiceMod];

// Serialize user so it can be stored in session
function _serialize(user) {
  // Address can be null
  let address = null;
  if (user.address != null) {
    address = user.address.copy();
    delete address.change_id;
  }

  const data = Object.assign({}, user, {address});
  delete data.change_id;

  return data;
}

// Deserialize data read from the session to a user object
function _deserialize(data) {
  const address = new Address();
  Object.assign(address, data.address);
  address.makeImmutable();

  const u = new User();
  Object.assign(u, data, {address});

  return u.makeImmutable();
}

export {checkSessionAuth, syncAuthToSession};



// WEBPACK FOOTER //
// ./src/app/auth/auth-session.storage.js